"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["StatementGenerated"] = "StatementGenerated";
    EventType["BillCreated"] = "BillCreated";
    EventType["DrawdownCompleted"] = "DrawdownCompleted";
    EventType["ComplianceCheckDue"] = "ComplianceCheckDue";
    EventType["CommunicationRequested"] = "CommunicationRequested";
    EventType["ReconciliationCompleted"] = "ReconciliationCompleted";
    EventType["ImportCompleted"] = "ImportCompleted";
    EventType["EvidenceFileUploaded"] = "EvidenceFileUploaded";
    EventType["ComplianceReminderDue"] = "ComplianceReminderDue";
    EventType["ComplianceOverdue"] = "ComplianceOverdue";
    EventType["AuditEntryCreated"] = "AuditEntryCreated";
})(EventType = exports.EventType || (exports.EventType = {}));
